import React, { useEffect, useState, useContext } from 'react';
import Layout from 'components/sales/layout/layout';
import localization from 'assets/localization/localization';
import { BaseUrl } from 'contexts/baseUrl/baseUrl';
import CardSection from 'components/sales/cardSection/cardSection';
import DivLayout from 'components/sales/divLayout/divLayout';
import { Button } from 'react-bootstrap';
import Config from "services/config/config";
import axios from "services/interceptor/Interceptor";
import { toast } from 'react-toastify';

const SiteGates = ({
  history,
  match,
  getgatesByleadId,
  siteGatesData
}) => {
  const { baseUrl } = useContext(BaseUrl);
  const [isLoading, setIsLoading] = useState(false);
  const [gateData, setGatesData] = useState([]);
  const [isValid, setIsValid] = useState(false);
  const [mappingComplete, setMappingCompete] = useState(0);
  const [isDisabled, setIsDisabled] = useState(false);
  
  console.log('PAGE:: SITE GATES');
  //console.log('mapping ' + mappingComplete);

  useEffect(() => {
     if(localStorage.getItem('inputListData') != undefined) {
      localStorage.removeItem('inputListData');
     }
     if(match.params.lead_id != null || match.params.lead_id != undefined) {
        (async () => {
          await getgatesByleadId(match.params.lead_id);
        })();
     }
  },[match.params.lead_id]);

  useEffect(() => {
      if(siteGatesData) {
        setGatesData(siteGatesData?.data);
        setIsValid(siteGatesData?.isValid);
        setMappingCompete(siteGatesData?.all_complete);
      }
  },[siteGatesData]);

  const handleCompleteAssetMapping = () => {
      let lead_id = match.params.lead_id;
      if(lead_id && lead_id !== undefined) {
        (async () => {
          setIsDisabled(true);
          setIsLoading(true);
          const url = `${Config.installation.markCompleteAssetMapping}?lead_id=${lead_id}`;
          const { data } = await axios.post(url);
          if(data && data?.response.data == true) {
            setIsLoading(false);
            toast.success('Updated Successfully.');
            setTimeout((function() {
              window.location.reload();
            }), 3000);
          } else {
            toast.error('Something went wrong, please try again.');
          }
          setIsLoading(false);
        })();
      } 
  }

  const headerBtns = () => {
    return (
        <>
        {gateData?.length > 0 && isValid == true && mappingComplete === 0 &&
          <Button
                disabled={isDisabled}
                onClick={() => handleCompleteAssetMapping()}
                className="filter-hamburger btn btn-transparent filter-btn-dir filters_direction filters-section"
            >
            <b className="site_filters" style={{width:"max-content"}}>
                {'Complete'}
            </b>
          </Button>
        }
        {gateData?.length <= 0 &&
          <span style={{color:'red'}}>No gate found</span>
        }   
        {mappingComplete === 1 &&
          <span style={{color:'green'}}>Mapping Completed</span>
        } 
        </>
    );
  };

  return (
    <Layout
      title={localization.sitesGates}
      isLoading={isLoading}
      Buttons={headerBtns}
      isGoback
    >
    {gateData && gateData?.length > 0 && gateData.map((value,index) => {
      return (
        <CardSection title={localization.solution + ' ' + (index+1)} key={index}>
            <div className="details-listing">
              <DivLayout
                  heading={localization.gate}
                  data={value.gate_name}
              />
              <DivLayout
                  heading={localization.gateDescription}
                  data={value.detail}
              />
              {value.found_asset_mapping  && value.found_asset_mapping !== null ? (
                <div className='col-md-12' style={{'padding':'15px 0px 15px 0px'}}>
                <a href={`/dashboard/mapped-assets/`+value.id +'/'+ value.found_asset_mapping} className='btn btn-primary btn-green-v1'>Mapped Assets</a>
              </div>
              ):<div className='col-md-12' style={{'padding':'15px 0px 15px 0px'}}>
                <a href={`/dashboard/asset-gate-mapping/`+value.id +'/'+ value.gate_setup_id+'/'+value.lead_id} className='btn btn-primary btn-red'>Map Asset</a>
                </div>}
            </div>
        </CardSection>        
      )
    })}
    </Layout>
  );
};

export default SiteGates;
